export enum KycStatus {
  PENDING = "STARTED",
  APPROVED = "APPROVED",
  DECLINED = "DECLINED",
}
